// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__UVZs4","rootSuccess":"CompleteLink_rootSuccess__j3jTZ","rootFailure":"CompleteLink_rootFailure__1A45y","isDisabled":"CompleteLink_isDisabled__1reC3"};